import { createSlice } from '@reduxjs/toolkit';

const fixedColumnsSlice = createSlice({
    name: 'fixedColumns',
    initialState: {
        columns: []
    },
    reducers: {
        setFixedColumns: (state, action) => {
            state.columns = action.payload;
        }
    }
});

export const { setFixedColumns } = fixedColumnsSlice.actions;
export default fixedColumnsSlice.reducer;
